import React from 'react';
import { FieldProps } from 'formik';
import { Checkbox } from '../ui/Checkbox';
import { cn } from '../../utils/cn';

interface CheckboxFieldOwnProps {
  label?: string;
  disabled?: boolean;
  className?: string;
}

type CheckboxFieldProps = FieldProps & CheckboxFieldOwnProps;

export const CheckboxField: React.FC<CheckboxFieldProps> = ({
  field,
  form: { touched, errors, submitCount, setFieldValue },
  label,
  disabled,
  className,
}) => {
  const hasError =
    (touched[field.name] && !!errors[field.name]) || (!!errors[field.name] && submitCount > 0);
  const errorMsg = hasError ? (errors[field.name] as string) : null;

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <div className="flex items-center gap-2">
        <Checkbox
          id={field.name}
          data-testid={`checkbox-field-${field.name}`}
          checked={field.value}
          onCheckedChange={(checked) => setFieldValue(field.name, !!checked)}
          disabled={disabled}
          aria-invalid={hasError}
        />
        {label && (
          <label
            htmlFor={field.name}
            className="text-sm text-neutral-700 select-none cursor-pointer"
          >
            {label}
          </label>
        )}
      </div>
      {hasError && <span className="text-destructive text-xs">{errorMsg}</span>}
    </div>
  );
};
